module.exports = __webpack_public_path__ + "static/img/1_12_1.de9d7437.jpg";